import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-084400b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "china-map-container f1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "咨询地区分布图"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "fs12 color-02",
    style: {"margin-top":"8px"}
  }, "点击地图上的省份可以查看省份城市的咨询数量")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "chat-china-map",
  style: {"width":"100%","height":"100%"}
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}